// removed by extract-text-webpack-plugin
module.exports = {"container":"VgafU"};


//////////////////
// WEBPACK FOOTER
// ./app/components/follow-user-button/follow-user-button.scss
// module id = 1596
// module chunks = 0